<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2 style="position: relative;">
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>E-postkontoer</v-breadcrumbs-item>

          <v-spacer />

          <v-btn color="primary" :to="{ 'name': 'email-detail', params: { type: getTabType().type, mail: 'new' } }">
            <v-icon>add</v-icon>
            Opprett {{ getTabType().verbose }}
          </v-btn>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="email-list" key="email-list" />

        <v-card>
          <v-tabs
            centered
            icons-and-text
            v-model="tab"
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-mailboxes">
              E-postkontoer
              <v-icon>email</v-icon>
            </v-tab>

            <v-tab href="#tab-forwards">
              Videresendinger
              <v-icon>forward</v-icon>
            </v-tab>

            <v-tabs-items>
              <v-tab-item id="tab-mailboxes">
                <v-data-table
                  :headers="mailboxHeaders"
                  :items="data.mailbox"
                  hide-actions
                  class="elevation-1"
                  item-key="mail"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                      <router-link class="big-link" :to="{ 'name': 'email-detail', params: { type: 'mailbox', mail: props.item.mail } }">
                        {{ props.item.mail }}
                      </router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.aliases.join(', ') }}</td>
                    <td class="text-xs-left">{{ props.item.used_size }}</td>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab-item id="tab-forwards">
                <v-data-table
                  :headers="forwardHeaders"
                  :items="data.forward"
                  hide-actions
                  class="elevation-1"
                  item-key="mail"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                      <router-link class="big-link" :to="{ 'name': 'email-detail', params: { type: 'forward', mail: props.item.mail } }">
                        {{ props.item.mail }}
                      </router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.aliases.join(', ') }}</td>
                    <td class="text-xs-left">{{ props.item.forwards.join(', ') }}</td>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import EmailService from '@/services/EmailService'

export default {
  name: 'email-list',
  mounted () {
    if (this.$route.hash) {
      this.tab = this.$route.hash.replace('#', '')
    }
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      tab: 'tab-mailboxes',
      mailboxHeaders: [
        { text: 'E-postadresse', sortable: false, class: 'has-big-links' },
        { text: 'Aliaser', sortable: false },
        { text: 'Brukt plass', sortable: false }
      ],
      forwardHeaders: [
        { text: 'E-postadresse', sortable: false, class: 'has-big-links' },
        { text: 'Aliaser', sortable: false },
        { text: 'Videresending til', sortable: false }
      ],
      data: {}
    }
  },
  methods: {
    async init () {
      const response = await this.runService(this, 'email-list', EmailService.getList)
      if (response) {
        this.data = response.data
      }
    },
    getTabType () {
      return this.tab === 'tab-mailboxes' ? {type: 'mailbox', verbose: 'e-postkonto'} : {type: 'forward', verbose: 'videresending'}
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 340px !important;
  font-size: 1.2em;
}

.card .v-btn {
  font-size: 1em;
}
</style>
